import { Plot } from '@/components/charts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { StatusFunnel } from '@/hooks/api/useAnalytics';
import { formatOpportunityStatus } from '@/lib/opportunity-status';

import { baseLayout, STATUS_COLORS } from './chart-config';

const ALL_STATUSES = ['new', 'actioned', 'dismissed'] as const;

interface Props {
  data: StatusFunnel[];
}

export function StatusFunnelChart({ data }: Props) {
  const countMap = new Map(data.map((d) => [d.status, d.count]));

  const statuses = ALL_STATUSES.map((s) => ({
    status: s,
    label: formatOpportunityStatus(s),
    count: countMap.get(s) ?? 0,
    color: STATUS_COLORS[s] || '#7a8fa3',
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Status Breakdown</CardTitle>
      </CardHeader>
      <CardContent>
        <Plot
          data={[
            {
              type: 'bar',
              orientation: 'h' as const,
              y: statuses.map((s) => s.label),
              x: statuses.map((s) => s.count),
              marker: {
                color: statuses.map((s) => s.color),
                line: { width: 0 },
              },
              text: statuses.map((s) => String(s.count)),
              textposition: 'inside' as const,
              textfont: { color: '#ffffff', size: 11 },
              insidetextanchor: 'end' as const,
              hovertemplate: '%{y}: %{x}<extra></extra>',
            },
          ]}
          layout={baseLayout({
            margin: { l: 90, r: 20, t: 10, b: 20 },
            xaxis: { title: { text: 'Count' }, gridcolor: 'rgba(148,163,184,0.15)' },
            yaxis: { autorange: 'reversed', gridcolor: 'rgba(148,163,184,0.15)', ticksuffix: '  ' },
            barcornerradius: 4,
          })}
          config={{ displayModeBar: false, responsive: true }}
          useResizeHandler
          className="h-64 w-full"
        />
      </CardContent>
    </Card>
  );
}
